const OfferState = {
  OPEN: 'open',
  ACCEPTED: 'accepted',
  REJECTED: 'rejected',
  INVOICED: 'invoiced',
  PROJECT_CREATED: 'projectCreated',
  ORDER_CREATED: 'orderCreated',
  SENT: 'sent',
  PRINTED: 'printed',
}

export default Object.freeze(OfferState)
